import { Icons } from '@agro-club/agroclub-shared'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { BidCreateModal } from 'views/pages/Bid/BidModals/BidCreateModal'

type Props = {
  companyId: string
}

export const CreateBid: FC<Props> = ({ companyId }) => {
  const { t } = useTranslation('bid')
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <AButton id="createBid" color="approve" Icon={Icons.IconAdd} onClick={() => setIsOpen(true)}>
        {t('newOffer')}
      </AButton>
      {isOpen && <BidCreateModal companyId={companyId} onClose={() => setIsOpen(false)} />}
    </>
  )
}
